const columnDataSemiAttrb = [
  {
    dataField: 'pfCertNo',
    caption: 'Номер СК ПФ',
    dataType: 'string'
  },
  {
    dataField: 'semiCgId',
    caption: 'Номер партии ПФ',
    dataType: 'string'
  },
  {
    dataField: 'semiActualPieceId',
    caption: 'Номер УЕ ПФ',
    dataType: 'string'
  }
];

export default columnDataSemiAttrb;
